import React from "react";
import "./Loading.css";

const Loading = () => {
  return (
    <div className="loading">
      <img
        className="loading-img"
        src={"https://wallpapercave.com/wp/wp2763507.png"}
        alt="Not found"
      />
    </div>
  );
};

export default Loading;
